import { useMemo, useState } from "react";
import { CustomActionDelete } from "../components/CustomActionDelete";
import { CustomActionToggle } from "../components/CustomActionToggle";
import { EndCallTriggerEdit } from "./EndCallTriggerEdit";
import { EndCallTriggerCreate } from "./EndCallTriggerCreate";
import { useCustomActions } from "../useCustomActions";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import EndCallTriggersTable from "./EndCallTriggersTable";
import { Heading } from "V2.0/common/heading";

function EndCallTriggers(props) {
  const { customActions, syncAssistant, workspaceId, assistantId, locked } =
    props;
  const { customActionsArray, autoCallEndEnabled } = customActions;
  const {
    removeCustomAction,
    createCustomAction,
    updateCustomAction,
    toggleCustomAction,
  } = useCustomActions({ syncAssistant, workspaceId, assistantId });
  const [openEdit, setOpenEdit] = useState({
    isOpen: false,
    item: null,
    index: null,
  });
  const [openDelete, setOpenDelete] = useState({
    isOpen: false,
    item: null,
    index: null,
  });

  const endCallTriggers = useMemo(() => {
    if (customActionsArray.length > 0) {
      return customActionsArray.filter(
        (action) => action.actionFunction === "CALLEND"
      );
    }

    return [];
  }, [customActionsArray]);

  const handleItemDelete = (lifecycleCbs) => {
    removeCustomAction(openDelete.item._id, lifecycleCbs);
  };

  const handleToggleCustomAction = (state) => {
    const loadingMessage = state
      ? "Enabling End Call Triggers.."
      : "Disabling End Call Triggers..";
    const successMessage = state
      ? "End Call Triggers enabled"
      : "End Call Triggers disabled";

    const lifecycleCbs = {
      init: () => {
        message.loading(loadingMessage);
      },
      success: () => {
        message.destroy();
        message.success(successMessage);
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to update End Call Triggers");
      },
    };

    const payload = { autoCallEndEnabled: state };
    toggleCustomAction(payload, lifecycleCbs);
  };

  const handleItemEdit = (data, lifecycleCbs) => {
    updateCustomAction(data, openEdit.item._id, lifecycleCbs);
  };

  return (
    <>
      <div className="w-3/4 min-w-[600px] m-4 flex flex-col gap-y-2 border rounded-lg">
        <div className="flex justify-between px-6 py-4 bg-gray-50 rounded-t-lg">
          <div className="flex items-center gap-x-2">
            <p className="text-md font-semibold text-gray-900">End Call Triggers</p>
            {!locked && (
              <CustomActionToggle
                isEnabled={autoCallEndEnabled}
                onToggleCustomAction={handleToggleCustomAction}
              />
            )}
          </div>
          {!locked && (
            <EndCallTriggerCreate onTriggerCreate={createCustomAction} />
          )}
        </div>
        <div className="min-h-96 px-6">
          <EndCallTriggersTable
            endCallTriggers={endCallTriggers}
            onEdit={setOpenEdit}
            onDelete={setOpenDelete}
            showActions={!locked}
          />
        </div>
      </div>
      {openDelete.isOpen && !locked && (
        <CustomActionDelete
          open={true}
          onClose={() =>
            setOpenDelete({ isOpen: false, item: null, index: null })
          }
          onDelete={handleItemDelete}
        />
      )}
      {openEdit.isOpen && !locked && (
        <EndCallTriggerEdit
          open={true}
          onClose={() =>
            setOpenEdit({ isOpen: false, item: null, index: null })
          }
          onTriggerEdit={handleItemEdit}
          endCallTrigger={openEdit.item}
        />
      )}
    </>
  );
}

export { EndCallTriggers };
